import React from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from '@mui/material';

import { useGetFeeSchedulesQuery } from '../../../../common/apis/AdminApi';
import { FeeSchedule } from '../../../types/FeeSchedule';

type Props = {
  onSelect: (feeSchedule: FeeSchedule) => void;
};

const FeeSchedulesTable: React.FC<Props> = ({ onSelect }) => {
  const { data, isFetching } = useGetFeeSchedulesQuery();

  const displayLimitedCodes = (codes: string[], limit: number) => {
    if (codes.length > limit) {
      return `${codes.slice(0, limit).join('; ')}...`;
    }
    return codes.join('; ');
  };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }}>
        <TableHead
          sx={{
            backgroundColor: (theme) => theme.palette.primaryLight?.main,
            height: 52,
          }}
        >
          <TableRow>
            <TableCell>
              <Typography fontWeight={500} color={'secondary'} fontSize={16}>
                Practice Name
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={500} color={'secondary'} fontSize={16}>
                Practice ID
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={500} color={'secondary'} fontSize={15}>
                Codes
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={500} color={'secondary'} fontSize={16}>
                Updated At
              </Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight={500} color={'secondary'} fontSize={16}>
                Created At
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        {isFetching && (
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: 0 }} colSpan={6}>
                <CircularProgress
                  color='primary'
                  size='64px'
                  style={{ display: 'block', margin: '24px auto' }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        )}
        {!isFetching && (
          <TableBody>
            {data?.map((schedule) => (
              <TableRow
                key={schedule.id}
                onClick={() => onSelect(schedule)}
                className={'admin-table-row'}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  cursor: 'pointer',
                }}
              >
                <TableCell>{schedule.practiceName}</TableCell>
                <TableCell>{schedule.practiceId}</TableCell>
                <TableCell>
                  <Typography fontSize={13} color={'secondary'}>
                    {displayLimitedCodes(schedule.codes, 36)}
                  </Typography>
                </TableCell>
                <TableCell>
                  {new Date(schedule.updatedAt).toLocaleString([], {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </TableCell>
                <TableCell>
                  {new Date(schedule.createdAt).toLocaleString([], {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default FeeSchedulesTable;
